module.exports = __webpack_public_path__ + "e54befb54e84430743862a3a5088b625.png";